import { createAction } from '@reduxjs/toolkit'

import { ICategory } from 'types/GlobalCategory'

// tryGetAllCategories
export const getAll = createAction('get_categories')
export const getAllSuccess = createAction<ICategory[]>('get_categories_success')
export const getAllFailed = createAction('get_categories_failed')
